function requestStatus() {
	"ngInject";
	return (status) => {
		switch(status){
		case "pending":
			return "badge-warning";
		case "accepted":
			return "badge-success";
		case "rejected":
			return "badge-danger";
		}
	};
}

export {requestStatus};


// WEBPACK FOOTER //
// ./sources/filters/requestStatus.js